import React, { useState } from 'react';
import MobileOrDesktopDialog from '@/components/common/mobileOrDesktopDialog';
import { StageAccordion } from './stageAccordion';
import {
    TimelineNextStep,
    TimelineStageTitle,
} from '@/constants/trackingStages';
import { ETrackingStages } from 'Constants/trackingStages';
import { useSelector } from 'react-redux';
import { TIMELINE_DATE_TIME } from 'Constants/dateTime';
import { parseAndFormat } from '@/utils/formatters';
import { hasItems, filterDuplicates } from '@/utils/common';
interface StatusUpdate {
    title: string;
    timestamp: string;
    status: string;
    isActive: boolean;
}

const Timeline = () => {
    const timelineData = useSelector((state: any) => state?.garage?.timeline);
    const [showTimeline, setShowTimeline] = useState(false);
    const currentStage = timelineData.latest_stage_details?.current_stage || '';
    const nextStep = TimelineNextStep[currentStage as ETrackingStages];
    const mappedData = filterDuplicates(timelineMapper(timelineData?.timeline));

    return (
        <>
            {nextStep && (
                <div
                    className="dropdown"
                    role="button"
                    onClick={() => setShowTimeline(true)}
                >
                    <div>
                        <span className="next-step">Next step:</span> {nextStep}
                    </div>
                    <i className="arrow"></i>
                </div>
            )}
            {hasItems(mappedData) && (
                <MobileOrDesktopDialog
                    isMobile={true}
                    show={showTimeline}
                    onClose={() => setShowTimeline(false)}
                    title="Timeline"
                >
                    {mappedData?.map((stage: any, index: number) => {
                        return (
                            <StageAccordion
                                key={index}
                                boxIndex={index + 1}
                                timestamp={parseAndFormat(
                                    stage.timestamp,
                                    TIMELINE_DATE_TIME
                                )}
                                isCurrentStage={stage.isActive}
                                stageCompleted={stage.status === 'COMPLETED'}
                                stageData={stage}
                                isNextStageClosed={
                                    mappedData?.[index + 1]?.title === 'closed'
                                }
                            />
                        );
                    })}
                </MobileOrDesktopDialog>
            )}

            <style jsx>{`
                .dropdown {
                    padding: 16px 24px;
                    background: white;
                    box-shadow: 0px 4px 8px -2px rgba(54, 53, 76, 0.06);
                    border-radius: 42px;
                    justify-content: space-between;
                    align-items: center;
                    gap: 16px;
                    display: flex;
                    color: #040222;
                    font-size: 14px;
                    font-weight: 600;
                    line-height: 20px;
                    word-wrap: break-word;
                    margin: 16px auto 0px;
                    max-width: 360px;
                    opacity: 0;
                    transform: translateY(20px);
                    animation: slideUp 0.4s 0.4s forwards;
                }

                .next-step {
                    font-weight: 400;
                }
                .arrow {
                    border: solid black;
                    border-width: 0 2px 2px 0;
                    display: inline-block;
                    padding: 3px;
                    transform: rotate(-135deg);
                    //margin-top: 10px;
                    cursor: pointer;
                }

                @keyframes slideUp {
                    0% {
                        transform: translateY(20px);
                        opacity: 0;
                    }
                    100% {
                        transform: translateY(0px);
                        opacity: 1;
                    }
                }
            `}</style>
        </>
    );
};
const timelineMapper = (data: any) => {
    let timelineData = data;

    if (timelineData && timelineData.length) {
        // Handle static CAR_AT_GARAGE stage from client (this is hack,need to be handled from backend)
        if (
            timelineData.length > 1 &&
            !timelineData.some(
                (stage: any) => stage.name === ETrackingStages.CAR_AT_GARAGE
            )
        ) {
            const dummyStage = timelineData.find(
                (stage: any) => stage.name === 'WELCOME'
            );

            timelineData = [
                ...timelineData,
                { ...dummyStage, name: ETrackingStages.CAR_AT_GARAGE },
            ];
        }

        return timelineData
            .map((stage: any) => {
                return {
                    title:
                        TimelineStageTitle[stage?.name as ETrackingStages] ||
                        '',
                    timestamp: stage?.created_at,
                    status: stage?.active ? 'PENDING' : 'COMPLETED',
                    isActive: stage?.active,
                };
            })
            .sort((a: any, b: any) => a.timestamp.localeCompare(b.timestamp));
    }
};

export default Timeline;
